<template>
  <div class="container-register-kit">
    <loading-screen v-if="loadingScreen" />
    <div class="" v-if="step === 0">
        <template v-if="shipping_type == 1">
          <div class="text">
          <h5 class="title-pink">Que bom que você chegou até aqui, agora falta pouco!</h5>
          <p class="purple bold">Lembre-se que a sua região está coberta pelo sistema de envios dos correios!</p>
          <p class="purple">Para seguir adiante, você já deve ter realizado sua coleta corretamente, esperado o tempo recomendado de 1 hora para
            secagem do cartão de coleta e colocado o mesmo dentro do saco hermético metalizado.</p>
          <p class="purple">Tudo pronto? <span class="bold">Então, com sua amostra devidamente embalada dentro do envelope preto, dirija-se a uma agência dos correios para encaminhar
            o seu exame ao laboratório.</span></p>
          <img src="@/assets/images/correios_3.png">
          <div class="form-actions">
            <button class="button btn-primary" v-on:click.prevent="toView(3)">Prosseguir</button>
          </div>
          </div>
        </template>
        <template v-if="shipping_type == 2">
          <h5>Viu, foi rápido e seguro! ;D</h5>
          <p>Preencha os campos a seguir e agende a coleta do seu KIT.</p>
            <div class="split"></div>
          <h4>Dados para coleta</h4>
          <form @submit="handleSubmit" class="form">
              <div class="input-box">
                <label for="zip" :class="{'has-error': errors && errors.zip_code}">CEP *</label>
                <input
                    type="text"
                    name="zip"
                    id="zip"
                    v-mask="'#####-###'"
                    @blur="findAddress"
                    v-model="form.zip_code" />
            <small class="error" v-if="errors && errors.zip_code">{{errors.zip_code.join()}}</small>
            </div>
            <div class="input-box sm">
                <label for="address" :class="{'has-error': errors && errors.address}">Logradouro *</label>
                <input
                    type="text"
                    name="address"
                    id="address"
                    v-model="form.address" />
            <small class="error" v-if="errors && errors.address">{{errors.address.join()}}</small>
            </div>
            <div class="input-box sm">
                <label for="address" :class="{'has-error': errors && errors.neighbourhood}">Bairro *</label>
                <input
                    type="text"
                    name="neighbourhood"
                    id="neighbourhood"
                    v-model="form.neighbourhood" />
            <small class="error" v-if="errors && errors.neighbourhood">{{errors.neighbourhood.join()}}</small>
            </div>
            <div class="input-box sm">
                <label for="number" :class="{'has-error': errors && errors.number}">Número *</label>
                <input
                    type="text"
                    name="number"
                    id="number"
                    v-model="form.number" />
            <small class="error" v-if="errors && errors.number">{{errors.number.join()}}</small>
            </div>
            <div class="input-box sm">
                <label for="address">Complemento</label>
                <input
                    type="text"
                    name="complement"
                    id="complement"
                    v-model="form.complement" />
            </div>
            <div class="input-box sm">
                <label for="address" :class="{'has-error': errors && errors.city}">Cidade *</label>
                <input
                    type="text"
                    name="city"
                    id="city"
                    v-model="form.city_name"
                    disabled />
            <small class="error" v-if="errors && errors.city">{{errors.city.join()}}</small>
            </div>
            <div class="input-box sm" :style="{'margin-bottom: 1.7rem' : !!turns}">
                <label for="state" :class="{'has-error': errors && errors.state}">Estado *</label>
                <input
                    type="text"
                    name="state"
                    id="state"
                    v-model="form.state_name"
                    disabled />
            <small class="error" v-if="errors && errors.state">{{errors.state.join()}}</small>
            </div>
            <div class="input-box sm" v-if="turns">
                <label class="datepicker-label" for="birthdate" :class="{'has-error': errors && errors.schedule}">Escolha a Data *</label>
                <select
                    name="schedule"
                    id="schedule"
                    @change="handleOnScheduleChange($event.target)">
                    <option value=null>Selecione uma opção</option>
                    <option v-for="(turn, key) in turns" v-bind:key="key" :value="key">
                        {{turn.day}} - {{turn.turn}} das {{turn.start_time}} às {{turn.end_time}}
                    </option>
                </select>
                <small class="error" v-if="errors && errors.schedule">{{errors.schedule.join()}}</small>
            </div>
            <div class="" v-if="notFound">
                <span>
                    Ops!! Infelizmente o local indicado ainda não faz parte da área de cobertura para coleta.
                    Indique um local em Porto Alegre/RS.
                </span>
            </div>
            <div class="form-actions" v-if="!notFound">
              <button class="button btn-primary" v-if="!loading" @click="handleSubmit">Salvar e Próximo</button>
              <button class="button btn-primary" v-if="loading" @click="handleSubmit" disabled><loading /></button>
            </div>
          </form>
        </template>
        <template v-if="shipping_type == 3">
          <h5>Que bom que você chegou até aqui, agora é com a gente!</h5>
          <p>Fique tranquilo que o nosso parceiro fará o envio da sua amostra para o nosso laboratório.</p>
          <p>Assim que recebermos sua coleta, iremos aferir seus exames e disponibilizá-los aqui no seu perfil mesmo.
            Você será notificado por e-mail e WhatsApp quando os resultados estiverem disponíveis para consulta.</p>
          <p>Agora é só aguardar e em poucos dias você receberá os resultados.</p>
          <div class="form-actions">
        
            <button class="button btn-primary" @click="toKits()">Voltar para meus Check-Ups</button>
          </div>
      </template>
    </div>
    <div v-if="step === 1">
    </div>
    <div v-if="step === 2">
		<h5>Viu, foi rápido e seguro! ;D</h5>
		<p>Preencha os campos a seguir e agende a coleta do seu KIT.</p>
			<div class="split"></div>
		<h4>Dados para coleta</h4>
      	<form @submit="handleSubmit" class="form">
        	<div class="input-box">
            <label for="zip" :class="{'has-error': errors && errors.zip_code}">CEP *</label>
            <input
                type="text"
                name="zip"
                id="zip"
                v-mask="'#####-###'"
                @blur="findAddress"
                v-model="form.zip_code" />
        <small class="error" v-if="errors && errors.zip_code">{{errors.zip_code.join()}}</small>
        </div>
        <div class="input-box sm">
            <label for="address" :class="{'has-error': errors && errors.address}">Logradouro *</label>
            <input
                type="text"
                name="address"
                id="address"
                v-model="form.address" />
        <small class="error" v-if="errors && errors.address">{{errors.address.join()}}</small>
        </div>
        <div class="input-box sm">
            <label for="address" :class="{'has-error': errors && errors.neighbourhood}">Bairro *</label>
            <input
                type="text"
                name="neighbourhood"
                id="neighbourhood"
                v-model="form.neighbourhood" />
        <small class="error" v-if="errors && errors.neighbourhood">{{errors.neighbourhood.join()}}</small>
        </div>
        <div class="input-box sm">
            <label for="number" :class="{'has-error': errors && errors.number}">Número *</label>
            <input
                type="text"
                name="number"
                id="number"
                v-model="form.number" />
        <small class="error" v-if="errors && errors.number">{{errors.number.join()}}</small>
        </div>
        <div class="input-box sm">
            <label for="address">Complemento</label>
            <input
                type="text"
                name="complement"
                id="complement"
                v-model="form.complement" />
        </div>
        <div class="input-box sm">
            <label for="address" :class="{'has-error': errors && errors.city}">Cidade *</label>
            <input
                type="text"
                name="city"
                id="city"
                v-model="form.city_name"
                disabled />
        <small class="error" v-if="errors && errors.city">{{errors.city.join()}}</small>
        </div>
        <div class="input-box sm" :style="{'margin-bottom: 1.7rem' : !!turns}">
            <label for="state" :class="{'has-error': errors && errors.state}">Estado *</label>
            <input
                type="text"
                name="state"
                id="state"
                v-model="form.state_name"
                disabled />
        <small class="error" v-if="errors && errors.state">{{errors.state.join()}}</small>
        </div>
        <div class="input-box sm" v-if="turns">
            <label class="datepicker-label" for="birthdate" :class="{'has-error': errors && errors.schedule}">Escolha a Data *</label>
            <select
                name="schedule"
                id="schedule"
                @change="handleOnScheduleChange($event.target)">
                <option value=null>Selecione uma opção</option>
                <option v-for="(turn, key) in turns" v-bind:key="key" :value="key">
                    {{turn.day}} - {{turn.turn}} das {{turn.start_time}} às {{turn.end_time}}
                </option>
            </select>
            <small class="error" v-if="errors && errors.schedule">{{errors.schedule.join()}}</small>
        </div>
        <div class="" v-if="notFound">
            <span>
                Ops!! Infelizmente o local indicado ainda não faz parte da área de cobertura para coleta.
                Indique um local em Porto Alegre/RS.
            </span>
        </div>
        <div class="form-actions" v-if="!notFound">
          <button class="button btn-primary" v-if="!loading" @click="handleSubmit">Salvar e Próximo</button>
          <button class="button btn-primary" v-if="loading" @click="handleSubmit" disabled><loading /></button>
        </div>
      </form>
    </div>
    <div v-if="step === 3">
		<div v-if="shipping_type == 1" class="text">
			<h5 class="">Prontinho! Mas, antes que corra para os correios, um lembrete:</h5>
			<p class="">Não esqueça de levar junto a sua "SOLICITAÇÃO DE AUTORIZAÇÃO DE POSTAGEM EM AGÊNCIA" que foi encaminhada junto com o seu Kit.</p>
			<p class="">E, qualquer dúvida pode entrar em contato com nosso SAC, viu? Teremos prazer em te auxiliar.</p>
			<img src="@/assets/images/correios_2.png">
			<div class="form-actions">
				<button class="button btn-primary" v-on:click.prevent="toKits">Voltar para meus Check-Ups</button>
			</div>
		</div>
      <div v-else class="text">
        <div class="text">
          <h5 class="">Parabéns!</h5>
          <p class="">Agendamento realizado com sucesso e em breve você receberá os resultados.</p>
          <img src="@/assets/images/vector-fluxo-healthid-lab-moto.png">
          <div class="form-actions">
            <button class="button btn-primary" v-on:click.prevent="toKits">Voltar para meus Check-Ups</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { POST_SCHEDULE } from "../../services/schedule";
  import { ADDRESS_FIND } from '../../services/address'
  import { CITY_TIME } from '../../services/address'

  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import 'vue2-datepicker/locale/pt-br';
  import moment from 'moment';

  export default {
    props: ['next', 'kit', 'shipping_type', 'tag_type'],
    components: {DatePicker},
    name: "DataKitSchedule",
    data: () => ({
		step: 0,
		loading: false,
		loadingScreen: false,
		errors: [],
		form: {
			zip_code: null,
			address: null,
			number: null,
			complement: null,
			neighbourhood: null,
			city: null,
			city_name: null,
			state: null,
			state_name: null,
			schedule: {},
			schedule_date: null,
		},
		turns: false,
		notFound: false,
    }),
    methods: {
		toView(n) {
			this.step = n;
        	window.scrollTo(0, 0);
		},
		clearErrors() {
			this.errors = [];
		},
		async findAddress() {
			this.clearErrors();
			if(this.form.zip_code.length === 9){
				this.notFound = false;
				this.loadingScreen = true;
				const response = await ADDRESS_FIND(this.form.zip_code);
				if(response && response.logradouro){
					this.form.address = response.logradouro;
					this.form.city_name = response.localidade;
					this.form.neighbourhood = response.bairro;
					const response2 = await CITY_TIME(response.uf, response.localidade);
					if(response2){
						this.form.state_id = response2.state_id;
						this.form.state_name = response2.state;
						this.form.city_id = response2.city_id;
						this.form.city_name = response2.city;
						this.turns = response2.turns
					}
				}else{
					this.errors.zip_code = ["CEP não encontrado."];
					this.form.address = null;
					this.form.city_name = null;
					this.form.state_id = null;
					this.form.state_name = null;
					this.form.city_id = null;
					this.turns = null;
				}
				this.loadingScreen = false;
			}
		},
		handleOnScheduleChange({value}) {
			if(this.turns[value]){
				this.form.schedule = this.turns[value];
				this.form.schedule_date = this.turns[value].full_date;
			}else{
				this.form.schedule = {};
			}
		},
      handleSubmit(event) {
			event.preventDefault();
			this.clearErrors();
			this.loading = true;
			let kit_number = this.kit;
			const form = { kit_number, ...this.form };
			POST_SCHEDULE(form).then(
				resp => {
					this.toView(3);
				},
         	 	error => this.errors = error.response.data,
        ).then(
          resp => {
            this.loading = false;
          }
        );
      },
      toKits() {
        this.$router.push('/kits');
        window.scrollTo(0, 0);
      },
    },
  }
</script>

<style scoped>
  .container-register-kit {
    max-width: 480px;
    margin: 0 auto;
  }
  .video-box {
    margin: 2rem 0;
  }
  .text h1 {
    font-size: 2.2rem;
  }

  h5.unweight {
    font-weight: normal;
  }

  p.bold,
  span.bold {
    font-weight: bold;
  }

  span.orange {
    color: #EB8E1A;
    font-weight: bold;
  }

  .text p {
    margin-top: 12px;
  }

  .text img {
    width: 100%;
    margin-bottom: 2rem;
  }
  .flex-fields {
    display: flex;
    justify-content: space-between;
  }
  .flex-fields input,
  .flex-fields .input-box sm input[type="text"], .input-box sm .mx-datepicker{
    height: 41px;
    margin-top: 10px;
  }
  .flex-fields input[type="time"] {
    width: 30%;
  }
  .input-box sm .mx-datepicker{
    width: 65%;
  }
  @media screen and (max-width: 410px) {
    .flex-fields {
      flex-direction: column;
    }
  .flex-fields input[type="time"],
  .input-box sm .mx-datepicker{
    width: 100%;
  }
  }
	.form-actions {
		margin-top: 1.75rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/RegisterKitSteps/DataKitSchedule.vue